import { FC, useMemo, useRef, useState } from 'react';
import { toast } from 'react-toastify';

import { ModalForm } from 'components/ModalForm';
import { useModal } from 'context/ModalProvider/useModal';
import { ValidationGroup } from 'devextreme-react';
import DataSource from 'devextreme/data/data_source';
import $createDataSource from 'utils/create-data-souce-instance';
import { isSuccess } from 'utils/responseStatus';

import { useCreateContractorPumpPriceMutation } from '../../api/ContractorPumpPrice';
import { ContractorPumpPriceForm } from '../../components';
import { CONTRACTOR_PUMP_PRICE_CRATE } from '../../ContractorDeliveryPrice.constants';
import { ContractorPumpPriceCreate } from '../../ContractorPumpPrice.entity';

type Props = {
  onRefresh: () => void;
  contractorId: number | string;
};

export const CreateContractorPumpPriceModal: FC<Props> = ({ onRefresh, contractorId }) => {
  const { hideModal } = useModal();
  const modalValidateRef = useRef<ValidationGroup>(null);

  const [form, setForm] = useState<ContractorPumpPriceCreate>(CONTRACTOR_PUMP_PRICE_CRATE);
  const [createDriverMixerSalary] = useCreateContractorPumpPriceMutation();

  const factoryDataStore: DataSource = useMemo(() => {
    const defaultFilter = ['parentId', '=', null];
    return $createDataSource('/v1/factory', 'id', { pageSize: 20, paginate: true, defaultFilter });
  }, []);

  const objectDataStore: DataSource = useMemo(() => {
    const defaultFilter = [['parentId', '=', null], 'and', ['type', '=', 1]];
    return $createDataSource(`/v1/ContractorObject/${contractorId}`, 'id', { defaultFilter });
  }, [contractorId]);

  const handleChange = (
    name: keyof ContractorPumpPriceCreate,
    value: ContractorPumpPriceCreate[keyof ContractorPumpPriceCreate],
  ) => {
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = () => {
    const isValid = modalValidateRef.current?.instance.validate().isValid;

    if (!isValid || !form) return;

    createDriverMixerSalary({ ...form, contractorId: Number(contractorId) }).then((data) => {
      if (isSuccess(data)) {
        onRefresh();
        hideModal();
        toast.success('Запись успешно создана', {
          position: 'bottom-right',
        });
      }
    });
  };

  return (
    <ModalForm
      onHidden={hideModal}
      title="Создание цены за насос"
      visible
      isLoadingSubmit={false}
      width={800}
      height="auto"
      textConfirm="Создать"
      hideOnOutsideClick={false}
      onSubmit={handleSubmit}
      ref={modalValidateRef}
    >
      <ContractorPumpPriceForm
        form={form}
        onChange={handleChange}
        factories={factoryDataStore}
        storeObject={objectDataStore}
        type="CREATE"
      />
    </ModalForm>
  );
};
